import { withInstall } from "../utils/index.mjs";
import _Button from "./Button.mjs";
const Button = withInstall(_Button);
var stdin_default = Button;
export {
  Button,
  stdin_default as default
};
